export function toQueryString(params: Record<string, string | number | boolean | null | undefined>): string {
  const query = Object.entries(params)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_key, value]) => value !== undefined && value !== null) // exclude null/undefined
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");

  return query;
}

export function getQueryParam(key: string, url: string = window.location.href): string | null {
  const params = new URL(url).searchParams;
  return params.get(key);
}

export default {
  toQueryString,
  getQueryParam,
};
